<div *ngIf="loading" style="margin-top: 64px;display: flex;justify-content: center;">
    <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
    </p-progressSpinner>
</div>

<div class="container-fluid" *ngIf="!loading">
    <div>
        <div class="row margin-top-8">
            <div class="header">
                {{editing ? ('bikeshop.rentals.accessories.edit' | translate) : ('bikeshop.rentals.accessories.add' |
                translate)}}
            </div>
        </div>
        <div class="info-container content">

            <div class="row" *ngIf="editing">
                <div class="col-md-4 label">
                    {{ 'bikeshop.rentals.products.identifier' | translate }}:
                </div>
                <div class="col-md-8 value">
                    {{accessory.identifier}}
                </div>
            </div>
            <div class="row margin-top-8">
                <div class="col-md-4 label" [ngClass]="{'red bold': accessory.accessoryCategoryID === 0 }">
                    {{ 'bikeshop.rentals.products.category' | translate }}:
                </div>
                <div class="value" [ngClass]="{'col-md-8': editing, 'col-md-7': !editing}">
                    <p-dropdown [options]="categoryOptions" [(ngModel)]="accessory.accessoryCategoryID"
                                [disabled]="cloneAccessory">
                    </p-dropdown>
                </div>
                <div class="col-md-1 value" *ngIf="!editing">
                    <span class="fa fa-plus-circle" (click)="addCategory()"
                          pTooltip="{{'bikeshop.rentals.category.add_category' | translate}}"></span>
                </div>
            </div>

            <div class="row margin-top-8">
                <div class="col-md-4 label"
                     [ngClass]="{'red bold': accessory.brand === undefined || accessory.brand.length === 0}">
                    {{ 'bikeshop.rentals.products.brand' | translate }}:
                </div>
                <div class="col-md-8 value">
                    <input type="text" pInputText
                           placeholder="{{'bikeshop.rentals.accessories.brand_placeholder' | translate}}"
                           [(ngModel)]="accessory.brand" [disabled]="cloneAccessory"/>
                </div>
            </div>

            <div class="row margin-top-8">
                <div class="col-md-4 label"
                     [ngClass]="{'red bold': accessory.name === undefined || accessory.name.length === 0}">
                    {{ 'bikeshop.rentals.accessories.name' | translate }}:
                </div>
                <div class="col-md-8 value">
                    <input type="text" pInputText
                           placeholder="{{'bikeshop.rentals.accessories.name_placeholder' | translate}}"
                           [(ngModel)]="accessory.name" [disabled]="cloneAccessory"/>
                </div>
            </div>

            <div class="row margin-top-8">
                <div class="col-md-4 label">
                    {{ 'bikeshop.rentals.products.color' | translate }}:
                </div>
                <div class="col-md-8 value">
                    <input type="text" pInputText
                           placeholder="{{'bikeshop.rentals.accessories.color_placeholder' | translate}}"
                           [(ngModel)]="accessory.color" maxlength="20"/>
                </div>
            </div>
        </div>

        <div class="info-container content" *ngIf="!editing">
            <div class="row">
                <div class="col-md-4 label"
                     [ngClass]="{'red bold': accessory.quantityToCreate <= 0 || accessory.quantityToCreate === ''}">
                    {{ 'bikeshop.rentals.products.quantity_to_create' | translate }}:
                </div>
                <div class="col-md-2 value">
                    <input type="number" pInputText
                           [(ngModel)]="accessory.quantityToCreate" (change)="updateSerialNumberArray()"/>
                </div>
            </div>
        </div>


        <div class="info-container content">
            <div class="row">
                <div class="col-md-4 label">
                    {{ 'bikeshop.rentals.products.size' | translate }}:
                </div>
                <div class="col-md-4 value">
                    <p-dropdown [options]="sizeOptions" [(ngModel)]="accessory.size" [editable]="true">
                    </p-dropdown>
                </div>
            </div>

            <div class="row margin-top-8">
                <div class="col-md-4 label">
                    {{ 'bikeshop.rentals.products.size_description' | translate }}:
                </div>
                <div class="col-md-8 value">
                    <input type="text" pInputText [disabled]="accessory.size === 'N/A'"
                           placeholder="{{'bikeshop.rentals.accessories.size_description_placeholder' | translate}}"
                           [(ngModel)]="accessory.sizeDescription"/>
                </div>
            </div>
        </div>

        <div class="info-container content">
            <div class="row">
                <div class="col-md-4 label">
                    {{ 'bikeshop.rentals.products.initial_accessory_value' | translate }}:
                </div>
                <div class="col-md-4 value">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">{{partnerData.CurrencySymbol}}</span>
                        <input type="number" pInputText [(ngModel)]="accessory.initialValue">
                    </div>

                </div>
            </div>
            <!-- <div class="row margin-top-8">
                <div class="col-md-4 label">
                  {{ 'bikeshop.rentals.accessories.activate_date' | translate }}
                </div>
                <div class="col-md-4 value">
                  <p-calendar [(ngModel)]="accessory.activatedDate" dateFormat="{{countryData.DatePickerFormat}}"
                    [showTime]="false"></p-calendar>
                </div>
              </div> -->
        </div>

        <div class="info-container content">
            <div class="row">
                <div class="col-md-4 label margin-top-0">
                    {{ 'bikeshop.rentals.accessories.description' | translate }}:
                </div>
                <div class="col-md-8 value">
                    <quill-editor [(ngModel)]="accessory.description" [style]="{'height':'280px'}" [modules]="modules"
                                  format="html"
                                  placeholder="{{ 'bikeshop.rentals.accessories.bike_description_placeholder' | translate}}">
                    </quill-editor>
                </div>
            </div>
        </div>

        <div class="info-container content" *ngIf="editing">
            <div class="row">
                <div class="col-md-4 label">
                    {{ 'bikeshop.rentals.products.serial_number' | translate }}:
                </div>
                <div class="col-md-8 value">
                    <input type="text" pInputText
                           placeholder="{{'bikeshop.rentals.accessories.serial_number_placeholder' | translate}}"
                           [(ngModel)]="accessory.serialNumber"/>
                </div>
            </div>

            <!-- <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ 'bikeshop.rentals.products.printable_serial_number' | translate }}:
              </div>
              <div class="col-md-8 value">
                <input type="text" pInputText
                  placeholder="{{'bikeshop.rentals.accessories.printable_serial_number_placeholder' | translate}}"
                  [(ngModel)]="accessory.printableSerialNumber" />
              </div>
            </div> -->
        </div>

        <div class="info-container content" *ngIf="!editing">
            <div *ngFor="let serialNumber of serialNumbers; let i = index">
                <div class="row" [ngClass]="{'margin-top-8': i > 0}">
                    <div class="col-md-4 label">
                        {{ 'bikeshop.rentals.products.serial_number' | translate }} #{{i + 1}}:
                    </div>
                    <div class="col-md-8 value">
                        <input type="text" pInputText [(ngModel)]="serialNumbers[i].serialNumber"/>
                    </div>
                </div>
            </div>
        </div>

        <div class="info-container content">
            <div class="row">
                <div class="col-md-4 label" [ngClass]="{'red bold': accessory.priceGroupID === 0 }">
                    {{ 'bikeshop.rentals.products.price_group' | translate }}:
                </div>
                <div class="col-md-8 value">
                    <p-dropdown [options]="priceGroupOptions" [(ngModel)]="accessory.priceGroupID">
                    </p-dropdown>
                </div>
            </div>
        </div>


        <!-- <div class="info-container content">
          <div class="row">
            <div class="col-md-12">
              <div class="sub-header">{{ 'bikeshop.rentals.products.linked_sku' | translate }}</div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 label margin-top-0">
              <small>{{ 'bikeshop.rentals.accessories.linked_sku_message' | translate }}</small>
            </div>
          </div>

          <div class="row margin-top-8">
            <div class="col-md-4 label">
              *{{ 'bikeshop.service_types.link_product' | translate }}:</div>
            <div class="col-md-8">
              <p-autoComplete [(ngModel)]="newSku" field="SKU" [suggestions]="searchResult" placeholder="{{
                        'bikeshop.modal.add_edit_service_types.linked_skus_form.enter_sku_or_name'
                          | translate
                      }}" (completeMethod)="searchAccessories($event)" (onSelect)="linkSku(newSku)">
                <ng-template let-product pTemplate="item">
                  <div>
                    <span>{{ product.SKU }} - {{ product.Name }}</span>
                  </div>
                </ng-template>
              </p-autoComplete>
            </div>
          </div>
          <div class="row margin-top-8" *ngIf="accessory.linkedInternalProductSKU">
            <div class="col-md-4 label"></div>
            <div class="col-md-8 label">{{accessory.linkedInternalProductSKU}} / {{accessory.linkedInternalProductName}}</div>
          </div>


        </div> -->

        <div class="info-container content">
            <div class="row" *ngIf="accessory.imageURL">
                <div class="col-md-12 margin-bottom-16">
                    <div class="primary-image" [ngClass]="{ 'primary-image-loading' : uploadingPrimaryImage}"
                         [ngStyle]="{'background-image': 'url('+accessory.imageURL+'), linear-gradient(0deg, white 0%, white 100%)'}">
                    </div>
                    <div class="primary-image-overlay" *ngIf="uploadingPrimaryImage">
                        <p-progressSpinner [style]="{ width: '30px', height: '30px' }"
                                           animationDuration=".5s"></p-progressSpinner>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-3"></div>
                <div class="col-md-6">
                    <button pButton class="p-button full-width"
                            [ngClass]="{'alternate':accessory.imageURL,'accent':!accessory.imageURL}"
                            label="{{'bikeshop.rentals.accessories.upload_primary_image' | translate}}"
                            [disabled]="uploadingPrimaryImage"
                            (click)="primaryUpload.click()"></button>
                    <input #primaryUpload type="file" style="display: none" (change)="primaryUploader($event)">
                </div>
                <div class="col-md-3"></div>
            </div>
        </div>

        <div class="info-container content">
            <div class="row">
                <div class="col-md-4 label">
                    {{ 'bikeshop.rentals.products.status' | translate }}:
                </div>
                <div class="col-md-8 value">
                    <div class="status-container">
                        <div [ngClass]="{'draft' : accessory.statusID === 1}"
                             (click)="accessory.statusID = 1">{{'bikeshop.rentals.products.draft' | translate}}</div>
                        <div [ngClass]="{'ready' : accessory.statusID === 10}"
                             (click)="accessory.statusID = 10">{{'bikeshop.rentals.products.ready_for_rental' | translate}}</div>
                        <div [ngClass]="{'repair' : accessory.statusID === 40}" (click)="accessory.statusID = 40"
                             *ngIf="accessory && accessory.id">{{'bikeshop.rentals.products.repair_needed' | translate}}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="margin-top-16 button-container">
            <div class="row margin-bottom-16" *ngIf="!isValid()">
                <div class="col-md-12">
                    <div class="red bold" style="font-size: 16px; text-align: right;">{{
                        'bikeshop.rentals.products.validation_message' | translate }}</div>
                </div>
            </div>
            <div style="display: flex; justify-content: space-between;">
                <div style="display: flex;">
                    <div *ngIf="editing" style="margin-right: 20px;">
                        <button *ngIf="!retiring" pButton
                                label="{{'bikeshop.rentals.accessories.retire_rental_accessory' | translate}}"
                                class="p-button-raised alternate" (click)="retireRentalAccessory()"
                                [disabled]="savingRentalAccessory"
                                style="width: 200px;"></button>
                        <div *ngIf="retiring">
                            <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
                            </p-progressSpinner>
                        </div>
                    </div>
                </div>
                <button *ngIf="!savingRentalAccessory" pButton (click)="saveRentalAccessory()" class="p-button-raised"
                        label="{{'bikeshop.general.save' | translate}}"
                        [disabled]="retiring || uploadingPrimaryImage || !isValid()"
                        style="width: 200px;"></button>
                <div *ngIf="savingRentalAccessory">
                    <p-progressSpinner [style]="{ width: '30px', height: '30px' }"
                                       animationDuration=".5s"></p-progressSpinner>
                </div>
            </div>
        </div>

    </div>
</div>


<p-confirmDialog key="add_edit_rental_product"></p-confirmDialog>
<!-- <p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast> -->
